export class LoginRequestModel {
    ClinicId: string;
    Password: string;

    constructor(ClinicId: string = '', Password: string = '') {
        this.ClinicId = ClinicId;
        this.Password = Password;
    }
}
